/**
 * @file 落地页 hooks
 * @author Fanjinliang(fanjinliang@baidu.com)
 */

import { useEffect, useState } from 'react';
import { fetchGetPaddleInfo } from '../../api/pages/paddleApi';
import { PaddleNlp } from './types';

const usePaddleNlp = () => {
    const [pageData, setPageData] = useState<PaddleNlp>({} as PaddleNlp);

    useEffect(() => {
        fetchGetPaddleInfo({ requestUrl: '/paddleNlpNew' }).then(res => {
            const data = res.body.result?.pageData || {};
            Object.keys(data).length > 0 && setPageData(data);
        });
    }, []);

    return {
        pageData
    };
};

export default usePaddleNlp;
